import { render, staticRenderFns } from "./dealWithDrawer.vue?vue&type=template&id=0abae076&scoped=true&"
import script from "./dealWithDrawer.vue?vue&type=script&lang=ts&"
export * from "./dealWithDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./dealWithDrawer.vue?vue&type=style&index=0&id=0abae076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abae076",
  null
  
)

export default component.exports